import { t } from '../../locales/index';
const whatsAppMarkDownPattern = {
	'<p>': '',
	'</p>': '\n',
	'<strong>': '*',
	'</strong>': '*',
	'<em>': '_',
	'</em>': '_',
	'<s>': '~',
	'</s>': '~',
	// '<ul> <li>': '- ',
	// '</li> <li>': '- ',
	// '</li> </ul>': '',
	// '<ul><li>': '- ',
	// '</li><li>': '- ',
	// '</li></ul>': '',
	// "</ul>" : "",
};

export const replaceMultiple = (input, replacements) => {
	let result = input;
	for (const searchStr in replacements) {
		if (Object.prototype.hasOwnProperty.call(replacements, searchStr)) {
			const replaceStr = replacements[searchStr];
			result = result.replace(new RegExp(searchStr, 'g'), replaceStr);
		}
	}
	return result;
};

export const htmlToMarkDown = (htmlContent) => {
	return replaceMultiple(htmlContent, whatsAppMarkDownPattern);
};

export const markDownToHtml = (text) => {
	return text
		.replace(/(.+?)\n/g, '<p>$1</p>')
		.replace(/\*(.+?)\*/g, '<strong>$1</strong>')
		.replace(/_(.+?)_/g, '<em>$1</em>')
		.replace(/~(.+?)~/g, '<s>$1</s>');
	// .replace(/- (.+?(?=\n|$))/g, '<ul> <li>$1</li> </ul>')
	// .replace(/^- (.*)/gm, '<ul> <li>$1</li> </ul>')
	// Replace </li> with <li>
	// .replace(/<\/li>/g, '<li>')
	// .replace(/\n\n/g, '</ul>')
	// Close the ul tag
	// .concat('\n</li></ul>')
};

export const useMarkdownConverter = (
	{ variablesIndices, ignoreNewLines } = { variablesIndices: {}, ignoreNewLines: false },
) => {
	const formatSymbols = {
		bold: '*', // strong
		italic: '_', // em
		strikethrough: '~', // del
		// mono: '```', // code
	};

	const symbols = Object.values(formatSymbols);
	const symbolTag = {
		[formatSymbols['bold']]: 'strong',
		[formatSymbols['italic']]: 'em',
		[formatSymbols['strikethrough']]: 'del',
	};

	const markdownToHtml = (text) => {
		if (!text) return '';

		let result = '';
		text = String(text)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');

		Object.keys(variablesIndices).forEach((variable) => {
			const varString = `{{${variablesIndices[variable]}}}`;
			text = text.replaceAll(varString, t(`whatsapp-variables.${variable}`));
		});

		const n = text.length;

		const isStartSpecialSymbol = (idx, text) => {
			if (!symbols.includes(text[idx])) return false;
			if (idx === 0) return true;
			if (idx === text.length - 1) return false;
			if (text[idx - 1] !== ' ' && text[idx - 1] !== '\n') return false;
			if (text[idx + 1] === ' ' || text[idx + 1] === '\n') return false;
			return true;
		};
		const isEndSpecialSymbol = (idx, text) => {
			if (!symbols.includes(text[idx])) return false;
			if (idx === text.length - 1) return true;
			if (idx === 0) return false;
			if (text[idx + 1] !== ' ' && text[idx + 1] !== '\n') return false;
			if (text[idx - 1] === ' ' || text[idx - 1] === '\n') return false;

			return true;
		};

		for (let i = 0; i < n; i++) {
			const c = text[i];
			if (c === '\n') {
				if (!ignoreNewLines) {
					result += '<br>';
				} else {
					result += '\n';
				}
				continue;
			}
			if (!isStartSpecialSymbol(i, text)) {
				result += c;
				continue;
			}
			let to = -1;
			for (let j = i + 1; j < n; j++) {
				if (text[j] === c && isEndSpecialSymbol(j, text)) {
					to = j;
					const subText = text.substring(i + 1, j);
					const subRes = markdownToHtml(subText);
					result += `<${symbolTag[c]}>`;
					result += subRes;
					result += `</${symbolTag[c]}>`;
					break;
				}
			}
			if (to === -1) {
				result += c;
			} else {
				i = to;
			}
		}

		return result;
	};

	return { markdownToHtml, formatSymbols };
};
